import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Shirt, Monitor, Home, Headphones, Baby, Tag, ArrowRight } from 'lucide-react';
const categories = [{
  id: 'apparel',
  title: 'Apparel',
  icon: Shirt,
  description: 'Bold fashion for Kings & Queens',
  subcategories: ['Kings', 'Queens', 'Heir', 'Heiress'],
  image: 'https://images.unsplash.com/photo-1556905055-8f358a7a47b2?auto=format&fit=crop&q=80&w=800',
  seasonal: 'FW24',
  isNew: true
}, {
  id: 'electronics',
  title: 'Electronics',
  icon: Monitor,
  description: 'Next-gen entertainment & gaming',
  image: 'https://images.unsplash.com/photo-1498049794561-7780e7231661?auto=format&fit=crop&q=80&w=800',
  seasonal: 'Holiday Drop'
}, {
  id: 'home',
  title: 'Home',
  icon: Home,
  description: 'Urban living essentials',
  image: 'https://images.unsplash.com/photo-1556911220-bff31c812dba?auto=format&fit=crop&q=80&w=800',
  seasonal: "Winter '24"
}, {
  id: 'sound',
  title: 'Sound',
  icon: Headphones,
  description: 'Premium audio experiences',
  image: 'https://images.unsplash.com/photo-1598488035139-bdbb2231ce04?auto=format&fit=crop&q=80&w=800',
  seasonal: 'FW24',
  isNew: true
}, {
  id: 'kids',
  title: 'KIDS!',
  icon: Baby,
  description: 'For the little legends',
  image: 'https://images.unsplash.com/photo-1519238263530-99bdd11df2ea?auto=format&fit=crop&q=80&w=800',
  seasonal: 'Holiday Drop'
}, {
  id: 'deals',
  title: 'Deals',
  icon: Tag,
  description: 'Exclusive limited time offers',
  image: 'https://images.unsplash.com/photo-1441986300917-64674bd600d8?auto=format&fit=crop&q=80&w=800',
  seasonal: 'Limited'
}];
export function CategoryGrid() {
  return <section className="py-24 bg-uncommon-black px-4 sm:px-6 lg:px-8" id="categories" data-id="element-11">
      <div className="max-w-7xl mx-auto" data-id="element-12">
        <div className="text-center mb-16" data-id="element-13">
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-4" data-id="element-14">
            SHOP <span className="text-uncommon-gold" data-id="element-15">U</span>NCMMN
          </h2>
          <p className="text-gray-400 max-w-2xl mx-auto" data-id="element-16">
            Curated collections for every aspect of your lifestyle.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-17">
          {categories.map((category, index) => <Link to={`/collection/${category.id}`} key={category.id} data-id="element-18">
              <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} className="group relative h-96 overflow-hidden rounded-lg border border-uncommon-grey bg-uncommon-dark cursor-pointer" data-id="element-19">
                {/* Background Image */}
                <div className="absolute inset-0" data-id="element-20">
                  <img src={category.image} alt={category.title} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110 opacity-60 group-hover:opacity-40" data-id="element-21" />
                  <div className="absolute inset-0 bg-gradient-to-t from-black via-black/50 to-transparent" data-id="element-22" />
                </div>

                {/* Seasonal Badge - Top Right */}
                <div className="absolute top-4 right-4 z-10" data-id="element-23">
                  <div className="bg-uncommon-gold text-black px-3 py-1 text-xs font-bold uppercase tracking-wider" data-id="element-24">
                    {category.seasonal}
                  </div>
                  {category.isNew && <div className="bg-white text-black px-3 py-1 text-xs font-bold uppercase tracking-wider mt-2" data-id="element-25">
                      New Drop
                    </div>}
                </div>

                {/* Content */}
                <div className="absolute inset-0 p-8 flex flex-col justify-end" data-id="element-26">
                  <div className="transform transition-transform duration-300 group-hover:-translate-y-2" data-id="element-27">
                    <div className="flex items-center gap-3 mb-2 text-uncommon-gold" data-id="element-28">
                      <category.icon size={24} data-id="element-29" />
                      <span className="text-sm font-bold uppercase tracking-wider" data-id="element-30">
                        Seasonal Drop
                      </span>
                    </div>

                    <h3 className="text-3xl font-bold text-white mb-2" data-id="element-31">
                      <span className="text-uncommon-gold" data-id="element-32">U</span>NCMMN{' '}
                      {category.title}
                    </h3>

                    <p className="text-gray-300 mb-4 opacity-0 group-hover:opacity-100 transition-opacity duration-300 delay-100" data-id="element-33">
                      {category.description}
                    </p>

                    {/* Subcategories for Apparel */}
                    {category.subcategories && <div className="space-y-2 mb-4 opacity-0 group-hover:opacity-100 transition-opacity duration-300 delay-150" data-id="element-34">
                        {category.subcategories.map(sub => <div key={sub} className="flex items-center text-sm text-gray-400 hover:text-white transition-colors" data-id="element-35">
                            <span className="w-1.5 h-1.5 bg-uncommon-gold rounded-full mr-2" data-id="element-36" />
                            <span className="text-uncommon-gold" data-id="element-37">U</span>NCMMN{' '}
                            {sub}
                          </div>)}
                      </div>}

                    <div className="flex items-center text-white font-bold text-sm uppercase tracking-wider group-hover:text-uncommon-gold transition-colors" data-id="element-38">
                      Shop Drop <ArrowRight className="ml-2 w-4 h-4" data-id="element-39" />
                    </div>
                  </div>
                </div>
              </motion.div>
            </Link>)}
        </div>
      </div>
    </section>;
}